import { get } from 'lodash-es'

import { request } from '@/common/utils/request'

export default {
  fetchBizoppNameSug: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getNameSug',
      ...params
    })
  },

  bizoppUpdateTags: params => {
    return request.post({
      url: 'crm.bdapp.bizopp.updateTags',
      params: params
    })
  },
  /*
   * 根据POI选择城市
   */
  getCityIdByPoi: params => {
    return request.get({
      url: 'crm.bdapp.index.common.getCityIdByPoi',
      params: params
    })
  },
  /*
   * 根据国家选择品类
   */
  getCategoryByCountry: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getCategoryByCountry',
      params: params
    })
  },

  add: params => {
    return request.post({
      url: 'crm.bdapp.bizopp.addApply',
      ...params
    })
  },

  update: params => {
    return request.post({
      url: 'crm.bdapp.bizopp.update',
      ...params
    })
  },

  getBizoppInfo: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getBizoppInfo',
      ...params
    })
  },

  getMyFaildeBizoppInfo: params => {
    return request.get({
      url: 'crm.bdapp.bizopp.getApplyBizoppInfo',
      params: params
    })
  },

  /**
   * sign 签约部分
   */
  getSignDetail: data => {
    return request.post({
      url: 'crm.bdapp.open.apply.get',
      data
    })
  },

  getContractInfo: data =>
    request.post({
      url: 'crm.bdapp.open.apply.get',
      data
    }),

  getCommonApplyBaseInfo (params) {
    return request.get({
      url: 'crm.bizopp.bizopp.getCommonApplyBaseInfo',
      params
    })
  },
  getSignAudit: data =>
    request.post({
      url: 'crm.bdapp.open.apply.get',
      data
    }),

  saveSignDetail: data =>
    request.post({
      url: 'crm.bdapp.open.apply.update',
      data
    }),

  submitSignDetail: data => {
    return request
      .post({
        url: 'crm.bdapp.open.apply.submitGlobal',
        data
      })
  },

  getSignShopAudit: data => {
    return request
      .post({
        url: 'crm.bdapp.open.apply.get',
        data
      })
      .then(res => {
        return get(res, 'data.auditGlobal', {})
      })
  },

  getCommonConfig: params => {
    return request
      .get({
        url: 'crm.common.getConfig',
        params
      })
  }
}
